// extracted by mini-css-extract-plugin
export default {"sticky":"fOaBOg9Bih2YJ0dUDxjZ","dateSwitcher":"MgiZ4ASujZDZJYbuy3Uc","placeHolderShimmer":"y9yV48EfMSCLY9S1Pvkh"};